module.exports = __webpack_public_path__ + "img/tasks.03663d34.svg";